import { useCallback } from 'react';
import { useShieldPRDTelemetry } from 'App/ShieldPRD/useShieldPRDTelemetry';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { useBrowserExtension } from 'Workspace/BrowserExtension/useBrowserExtension';

export const useShieldPRDTelemetryForBrowser = () => {
	const context = useBrowserExtension();
	const getExtraPayload = useCallback(async browserExtensionContext => {
		try {
			const config = await browserExtensionContext.getExtensionConfiguration();
			return { isExtensionAvailable: config.isActive };
		} catch {
			return { isExtensionAvailable: false };
		}
	}, []);

	return useShieldPRDTelemetry({
		featureFlag: FeatureFlag.ShieldPRD,
		context,
		getExtraPayload,
	});
};
